import axios from 'axios'
import {
    router
} from '.././router'
import Cookies from 'js-cookie';
let axiosAjax = axios.create({

    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
    timeout: 30000
});

function getDateNow() {
    var timeStr = '';
    var curDate = new Date();
    var curYear = curDate.getFullYear(); //获取完整的年份(4位,1970-????)
    var curMonth = curDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    var curDay = curDate.getDate(); //获取当前日(1-31)
    var curWeekDay = curDate.getDay(); //获取当前星期X(0-6,0代表星期天)
    var curHour = curDate.getHours(); //获取当前小时数(0-23)
    var curMinute = curDate.getMinutes(); // 获取当前分钟数(0-59)
    var curSec = curDate.getSeconds(); //获取当前秒数(0-59)
    var Current = curYear + timeStr + curMonth + timeStr + curDay + timeStr + curHour + timeStr + curMinute + timeStr + curSec;
    return Current
};


// 登录请求拦截 登陆注释的
axiosAjax.interceptors.request.use(config => {
        if (config.data) {
            // config.data.token = "e2948e09cf3d483aa812497fb4db10dd";
            // config.data.token = Cookies.get('token');
            // config.data.timestamp = getDateNow();
        } else { }
        return config;
    },
    err => {
        return Promise.reject(err);
    });
axiosAjax.interceptors.response.use(
    res => {
        if (res.data.code == 30000 || res.data.code == 500002) {
            // 需要登陆
            // Cookies.remove('userName');
            // Cookies.remove('userId');
            localStorage.clear();
            
        } else if (res.data.code == 30001) { }
        return res;
    },
    error => {

        return Promise.reject(error.response.data)
    });
export default axiosAjax